exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pdf-thumbnail{display:flex;flex-direction:column;align-items:center;gap:6px;width:100%;padding:8px;border:2px solid transparent;border-radius:6px;color:#4b5563}.pdf-thumbnail:hover{background:#e5e7eb}.pdf-thumbnail-active{border-color:#2563eb;background:#eff6ff;color:#1d4ed8}.pdf-thumbnail-image{display:block;width:100%;background:#fff;box-shadow:0 1px 4px rgba(0,0,0,.2);overflow:hidden}.pdf-thumbnail-image canvas{display:block;width:100%;height:100%}", ""]);

// exports
